import './index.scss';

import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import axios from '../../admin-axios';
import { ReactComponent as ArrowDown } from '../../assets/Images/arrow_down.svg';
import { ReactComponent as ArrowUp } from '../../assets/Images/arrow_up.svg';
import { ReactComponent as CallIcon } from '../../assets/Images/call_icon.svg';
import { ReactComponent as CameraIcon } from '../../assets/Images/camera_icon.svg';
import { ReactComponent as CustomerIcon } from '../../assets/Images/customer_icon.svg';
import { ReactComponent as DeactivateIcon } from '../../assets/Images/deactivate_icon.svg';
import { ReactComponent as DesignationIcon } from '../../assets/Images/designation_icon.svg';
import picsDP from '../../assets/Images/pics_DP.png';
import useActions from '../../hooks/useActions';
import { detectError } from '../../utils';

const StaffView = () => {
  const { Id } = useParams();
  const [staff, setStaff] = useState();
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [arrowState, setArrowState] = useState(false);
  const [showUpdate, setUpdateShow] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [showReset, setResetShow] = useState(false);
  const [showStatus, setStatusShow] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [reload, setReload] = useState(false);

  const handleUpdateClose = () => setUpdateShow(false);
  const handleUpdateShow = () => setUpdateShow(true);

  const handleResetClose = () => setResetShow(false);
  const handleResetShow = () => setResetShow(true);

  const handleStatusClose = () => setStatusShow(false);
  const handleStatusShow = () => setStatusShow(true);

  const phoneRef = useRef(null);
  const designationRef = useRef(null);

  const { designation } = useSelector((state) => state.designations);
  const { user } = useSelector((state) => state.auth);
  const { page } = useSelector((state) => state.staffs);
  const { getStaffs } = useActions();

  const { setBackLink } = useActions();

  let designation_id = 0;
  if (staff) {
    designation_id = designation.find((d) => d.name === staff.designation).id;
  }

  const saveChangesHandler = () => {
    if (
      phoneRef.current.value !== staff.phone ||
      Number(designationRef.current.value) !== designation_id
    ) {
      handleUpdateShow();
    }
  };

  const resetPasswordHandler = () => {
    handleResetShow();
  };

  const updateStaffHandler = async () => {
    try {
      setUpdateLoading(true);
      // `/staff/update/${staff.staff_id}/${user.stationId}/${user.id}`
      await axios.patch(`/staff/update/${staff.staff_id}`, {
        station_id: user.stationId,
        firstname: staff.firstname,
        lastname: staff.lastname,
        phone: phoneRef.current.value,
        designation_id: designationRef.current.value,
        kin_firstname: staff.NextofKin_firstname,
        kin_lastname: staff.NextofKin_lastname,
        kin_relationship: staff.NextofKin_relationship,
        kin_phone: staff.NextofKin_phone,
        created_by: user.id
      });
      setUpdateLoading(false);
      toast.success('Profile Updated Successfully');
      handleUpdateClose();
      setReload((value) => !value);
      // get updated table
      getStaffs(user.stationId, page);
    } catch (e) {
      setUpdateLoading(false);
      toast.error(detectError(e));
      handleUpdateClose();
    }
  };

  const resetStaffHandler = async () => {
    try {
      setResetLoading(true);
      await axios.get(`/staff/reset/${staff.staff_id}/${user.stationId}/${user.id}`);
      setResetLoading(false);
      toast.success('Reset Password Successfully');
      handleResetClose();
    } catch (e) {
      setResetLoading(false);
      toast.error(e.message);
      handleResetClose();
    }
  };

  const changeStatusHandler = async () => {
    try {
      if (staff) {
        setStatusLoading(true);
        if (staff.status === 'Active') {
          await axios.get(`/staff/disable/${staff.staff_id}/${user.stationId}/${user.id}`);
        }
        if (staff.status === 'Deactivated') {
          await axios.get(`/staff/activate/${staff.staff_id}/${user.stationId}/${user.id}`);
        }
        setStatusLoading(false);
        toast.success(`${staff.status === 'Active' ? 'Deactivation' : 'Activation'} Successful`);
        setReload((value) => !value);
        getStaffs(user.stationId, page);
        handleStatusClose();
      }
    } catch (e) {
      setStatusLoading(false);
      toast.error(e.message);
      handleStatusClose();
    }
  };

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        setLoadingStaff(true);

        const response = await axios.get(`/staff/view/${Id}`);

        setStaff(response.data.data);

        setLoadingStaff(false);
      } catch (e) {
        // setBackLink('/staffs');
        setLoadingStaff(false);
      }
    };

    fetchStaff();
  }, [Id, reload]);

  useEffect(() => {
    return () => {
      setBackLink('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <div>
        {loadingStaff ? (
          <div className="d-flex justify-content-center w-100">
            <Spinner className="spinner" animation="border" variant="dark" />
          </div>
        ) : (
          <div className="staff_view">
            <div className="row g-3 mb-5">
              <div className="offset-sm-2 col-sm-4 offset-xl-7 col-xl-2">
                <div className="d-flex align-items-center justify-content-sm-end h-100">
                  <span className="me-2 text-muted">Enabled</span>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label className="staff_view_switch">
                    <input type="checkbox" />
                    <span className="staff_view_switch_slider staff_view_switch_slider_round">
                      &nbsp;
                    </span>
                  </label>
                </div>
              </div>
              <div className="col-sm-6 col-xl-3">
                <div className="w-100">
                  {staff && staff.status === 'Active' ? (
                    <button
                      type="button"
                      onClick={() => handleStatusShow()}
                      className="w-100 btn btn-danger btn-lg d-flex align-items-center justify-content-center">
                      <DeactivateIcon className="me-2 staff_view_button_icon" />
                      Deactivate Staff
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => handleStatusShow()}
                      className="w-100 btn btn-success btn-lg d-flex align-items-center justify-content-center">
                      <DeactivateIcon className="me-2 staff_view_button_icon" />
                      Activate Staff
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="row g-3 mb-5">
              <div className="col-xl-6">
                <div className="bg-light staff_view_bio p-2">
                  <div className="row h-100 w-100">
                    <div className="col-sm-5">
                      <div className="staff_view_bio_image h-100 d-flex align-items-center justify-content-center justify-content-sm-end">
                        <div className="staff_view_bio_imagebox">
                          <img src={picsDP} alt="display" />
                          <CameraIcon className="staff_view_bio_imagebox_icon" />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-7">
                      <div className="h-100 d-flex align-items-center justify-content-center justify-content-sm-start">
                        <div className="staff_view_details">
                          <h3>{staff && `${staff.lastname} ${staff.firstname}`}</h3>
                          <p className="mb-4">
                            Date registered:{' '}
                            {staff && new Date(staff.registered_date).toDateString()}
                          </p>
                          <div className="staff_view_details_div">
                            <span className="staff_view_details_div_text">
                              {staff && staff.status}
                            </span>{' '}
                            {staff && staff.status === 'Active' ? (
                              <span className="staff_view_details_div_active">&nbsp;</span>
                            ) : (
                              <span
                                style={{ left: staff?.status === 'Deactivated' ? '90px' : '60px' }}
                                className="staff_view_details_div_inactive">
                                &nbsp;
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="bg-light staff_view_info">
                  <div className="row g-5">
                    <div className="col-sm-5">
                      <div className="d-flex">
                        <CustomerIcon className="me-3 staff_view_info_icon" />
                        <div>
                          <div className="text-muted">Staff ID</div>
                          <div>{staff?.staff_id}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-7">
                      <div className="d-flex">
                        <CallIcon className="me-3 staff_view_info_icon" />
                        <div>
                          <div className="text-muted">Phone Number</div>
                          <div>{staff?.phone}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="d-flex">
                        <DesignationIcon className="me-3 staff_view_info_icon" />
                        <div>
                          <div className="text-muted">Designation</div>
                          <div>{staff?.designation}</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-7">
                      <div className="w-100 staff_view_more_details">
                        <button
                          onClick={() => {
                            setArrowState((value) => !value);
                          }}
                          type="button"
                          className="btn d-flex align-items-center justify-content-between w-100 staff_view_update_btn">
                          <span className="p-2">View More</span>
                          <span>{arrowState ? <ArrowUp /> : <ArrowDown />}</span>
                        </button>
                        {arrowState ? (
                          <div className="w-100 staff_view_more_details_box">
                            <div className="d-flex m-2">
                              <CustomerIcon className="me-3 staff_view_info_icon" />
                              <div>
                                <div className="">Next of Kin's Name</div>
                                <div>
                                  {staff?.NextofKin_lastname} {staff?.NextofKin_firstname}
                                </div>
                              </div>
                            </div>
                            <div className="d-flex m-2">
                              <CustomerIcon className="me-3 staff_view_info_icon" />
                              <div>
                                <div className="">Relationship</div>
                                <div className="next_of_kin">{staff?.NextofKin_relationship}</div>
                              </div>
                            </div>
                            <div className="d-flex m-2">
                              <CallIcon className="me-3 staff_view_info_icon" />
                              <div>
                                <div className="">Phone Number</div>
                                <div>{staff?.NextofKin_phone}</div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h4>Update Profile</h4>
            <div className="row g-4 mb-5">
              <div className="col-lg-6">
                <div>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="phone_no">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone_no"
                    id="phone_no"
                    placeholder="Phone Number"
                    defaultValue={staff?.phone}
                    ref={phoneRef}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label>Designation</label>
                  <select
                    defaultValue={designation_id}
                    ref={designationRef}
                    className="form-select form-select-lg"
                    aria-label=".form-select-lg example">
                    <option value="">Options</option>
                    {designation?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-12">
                <button
                  onClick={saveChangesHandler}
                  type="button"
                  className="btn staff_view_update_btn p-3">
                  Save Changes
                </button>
              </div>
            </div>
            <hr />
            <h4 className="mb-3">Password</h4>
            <button
              onClick={resetPasswordHandler}
              type="button"
              className="btn staff_view_update_btn p-3">
              Reset Password
            </button>
          </div>
        )}
      </div>
      <Modal size="md" centered show={showUpdate} onHide={handleUpdateClose} animation>
        <Modal.Header closeButton>
          <Modal.Title>Update Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to update this profile?</Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            className="me-3 staff_modal_update_no"
            variant="outline-primary"
            onClick={handleUpdateClose}>
            No
          </Button>
          {updateLoading ? (
            <div className="">
              <Spinner className="spinner" animation="border" variant="dark" />
            </div>
          ) : (
            <Button
              variant="primary"
              className="me-3 staff_modal_update_yes"
              onClick={updateStaffHandler}>
              Yes
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal size="md" centered show={showReset} onHide={handleResetClose} animation>
        <Modal.Header closeButton>
          <Modal.Title>Reset Staff Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to reset the password for this staff?</Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            className="me-3 staff_modal_update_no"
            variant="outline-primary"
            onClick={handleResetClose}>
            No
          </Button>
          {resetLoading ? (
            <div className="">
              <Spinner className="spinner" animation="border" variant="dark" />
            </div>
          ) : (
            <Button
              variant="primary"
              className="me-3 staff_modal_update_yes"
              onClick={resetStaffHandler}>
              Yes
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <Modal size="md" centered show={showStatus} onHide={handleStatusClose} animation>
        <Modal.Header closeButton>
          <Modal.Title>{staff?.status === 'Active' ? 'Deactivate' : 'Activate'} Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to {staff?.status === 'Active' ? 'deactivate' : 'activate'} this
          staff in the system?
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            className="me-3 staff_modal_update_no"
            variant="outline-primary"
            onClick={handleStatusClose}>
            No
          </Button>
          {statusLoading ? (
            <div className="">
              <Spinner className="spinner" animation="border" variant="dark" />
            </div>
          ) : (
            <Button
              variant="primary"
              className="me-3 staff_modal_update_yes"
              onClick={changeStatusHandler}>
              Yes
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StaffView;
